import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CodeBracketIcon, ArrowRightIcon, SparklesIcon } from '@heroicons/react/24/outline';

const SimplePracticeCodingButton = () => {
 const navigate = useNavigate();

 const handleNavigateToCompiler = () => {
 navigate('/compiler');
 };

 const handleNavigateToTSG = () => {
 navigate('/tsg');
 };

  return (
    <div className="relative">
      {/* Highlighting background */}
      <div className="absolute inset-0 bg-gradient-to-r from-primary/20 via-secondary/20 to-primary/20 rounded-2xl blur-sm"></div>
      
      <div className="relative flex flex-col gap-4">
        {/* Compiler Button - Full Width */}
        <button
          onClick={handleNavigateToCompiler}
          className="w-full bg-gradient-to-r from-primary to-secondary text-white px-6 py-4 rounded-xl font-bold shadow-2xl hover:shadow-primary/50 transition-all duration-300 hover:scale-105 border-2 border-primary"
        >
          <div className="flex items-center justify-center space-x-3 mb-1">
            <CodeBracketIcon className="h-7 w-7" />
            <span className="text-xl">Ready to Code?</span>
            <ArrowRightIcon className="h-6 w-6" />
          </div>
          <div className="text-center">
            <span className="text-lg">Practice with Interactive Compiler</span>
          </div>
        </button>

        {/* TSG Button - Full Width */}
        <button
          onClick={handleNavigateToTSG}
          className="w-full bg-gradient-to-r from-secondary to-primary text-white px-6 py-4 rounded-xl font-bold shadow-2xl hover:shadow-secondary/50 transition-all duration-300 hover:scale-105 border-2 border-secondary"
        >
          <div className="flex items-center justify-center space-x-3 mb-1">
            <SparklesIcon className="h-7 w-7" />
            <span className="text-xl font-black">AI MENTOR</span>
            <ArrowRightIcon className="h-6 w-6" />
          </div>
          <div className="text-center">
            <span className="text-lg">Get Personalized AI Guidance</span>
          </div>
        </button>
      </div>
    </div>
  );
};

export default SimplePracticeCodingButton;



